import { KeyboardEvent, MouseEvent } from "react";

import { isFromNestedInteractiveElement } from "@shared";

const ACTIVATION_KEY = "Enter";

interface Params {
  onActivate?: () => void;
  disabled?: boolean;
}

export function useDocumentRowActivation({ onActivate, disabled = false }: Params) {
  const onClick = (event: MouseEvent<HTMLElement>) => {
    const target = event.target;
    if (disabled || onActivate === undefined || !(target instanceof Element) || !event.currentTarget.contains(target)) {
      return;
    }
    if (isFromNestedInteractiveElement(target, event.currentTarget)) {
      return;
    }
    onActivate();
  };

  const onKeyDownCapture = (event: KeyboardEvent<HTMLElement>) => {
    if (disabled || onActivate === undefined || event.key !== ACTIVATION_KEY || event.target !== event.currentTarget) {
      return;
    }
    event.preventDefault();
    onActivate();
  };

  return { onClick, onKeyDownCapture };
}
